import Noodle from '@components/Icons/Noodle';
import NoodleTheme from '@components/NoodleTheme';
import Image from 'next/image';
import { FC } from 'react';
import { useFeatureFlag } from '@/providers/FeatureFlags';

import s from './PoweredByNoodle.module.scss';

type Props = {
  style?: React.CSSProperties;
  isVertical?: boolean;
};

const PoweredByNoodle: FC<Props> = ({ style, isVertical }) => {
  const canShowGlade = useFeatureFlag('is-glade-dot-ai');

  return (
    <NoodleTheme>
      <div className={s.wrapper} style={style} data-translate="false">
        <a className={isVertical ? s.poweredVertical : s.powered} target="_blank" rel="noopener noreferrer" href="https://www.glade.ai">
          Powered by{' '}
          {canShowGlade
            ? <span>
              <Image src="/full-glade-logo.png" width={72} height={16} alt="Glade AI" style={{ position: 'relative', top: 3 }} />
            </span>
            : <span>
              <Noodle width={12} height={12} fill="var(--color-noodle)" />
              <span>noodle</span>
            </span>}
        </a>
      </div>
    </NoodleTheme>
  );
};

export default PoweredByNoodle;
